module.exports = __webpack_public_path__ + "media/images/indeed-2021-logo-blue-895c9ab825bd2dff9711603b5ea566ed.png";